import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-winlose-detail-lotto',
  templateUrl: './winlose-detail-lotto.component.html',
  styleUrls: ['./winlose-detail-lotto.component.scss']
})
export class WinloseDetailLottoComponent implements OnInit {
  @Input() DetailLotto: any;

  constructor() { }

  ngOnInit() {
  }

}
